import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { isActiveCliente } from '@/utils/clientes';
import SearchableCombobox from '@/components/ui/searchable-combobox';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NewManualOfferDialog = ({
  open,
  onOpenChange,
  onSuccess,
  lotes = {},
  clientes = {},
  preselectedLote = null
}) => {
  const [newOffer, setNewOffer] = useState({
    loteId: preselectedLote ? preselectedLote.id : '',
    clienteId: '',
    monto: '',
  });

  useEffect(() => {
    if (open) {
      setNewOffer({
        loteId: preselectedLote ? preselectedLote.id : '',
        clienteId: '',
        monto: '',
      });
    }
  }, [open, preselectedLote]);

  const handleCreateOffer = async () => {
    try {
      if (!newOffer.loteId || !newOffer.clienteId || !newOffer.monto) {
        toast.error('Completa todos los campos');
        return;
      }

      await axios.post(`${API}/ofertas`, {
        loteId: newOffer.loteId,
        clienteId: newOffer.clienteId,
        monto: parseFloat(newOffer.monto),
        esManual: true,
      });

      toast.success('Oferta creada manualmente');
      onOpenChange(false);
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Error creating local offer:', error);
      toast.error('Error al crear oferta');
    }
  };

  const loteOptions = Object.values(lotes)
    .filter(v => ['Enviada', 'En espera'].includes(v.estadoPublicacion))
    .map(v => ({
      value: v.id,
      label: `${v.tipoGanado} ${v.categoria} ${v.numeroLote}`,
      searchValue: `${v.tipoGanado} ${v.categoria} ${v.numeroLote} ${v.id}`,
    }));

  const clienteOptions = Object.values(clientes)
    .filter(isActiveCliente)
    .map(r => ({
      value: r.id,
      label: `${r.nombre} - ${r.empresa}`,
      searchValue: `${r.nombre} ${r.empresa} ${r.id}`,
    }));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Cargar Oferta Manual</DialogTitle>
          <DialogDescription>
            Registra una oferta recibida de forma manual
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="lote">Vehículo</Label>
            {preselectedLote ? (
              <div className="p-3 bg-muted rounded-md border text-sm font-medium">
                {preselectedLote.tipoGanado} {preselectedLote.categoria} {preselectedLote.numeroLote}
              </div>
            ) : (
              <SearchableCombobox
                value={newOffer.loteId}
                onSelect={(val) => setNewOffer({ ...newOffer, loteId: val })}
                options={loteOptions}
                placeholder="Seleccionar vehículo..."
                searchPlaceholder="Buscar vehículo..."
                emptyText="No se encontraron lotes."
                contentClassName="w-[400px] sm:w-[500px]"
              />
            )}
          </div>

          <div className="space-y-2">
            <Label htmlFor="cliente">Cliente</Label>
            <SearchableCombobox
              value={newOffer.clienteId}
              onSelect={(val) => setNewOffer({ ...newOffer, clienteId: val })}
              options={clienteOptions}
              placeholder="Seleccionar cliente..."
              searchPlaceholder="Buscar cliente..."
              emptyText="No se encontró cliente."
              contentClassName="w-[400px] sm:w-[500px]"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="monto">Monto (USD)</Label>
            <Input
              id="monto"
              type="number"
              placeholder="15000"
              value={newOffer.monto}
              onChange={(e) => setNewOffer({ ...newOffer,  monto: e.target.value })}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={handleCreateOffer}>Crear Oferta</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default NewManualOfferDialog;
